function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Bone sliced up");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#F15A24",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M163.8,27.8c-0.9,0-1.8,0-2.6,0.1c-7.3-20.6-30-31.4-50.6-24.1C94.7,9.4,84.1,24.4,84.2,41.2 c0,3.9,0.6,7.8,1.7,11.6C88.3,60.4,93,67,99.3,71.9c-1.8,2.3-3.7,4.6-5.5,6.9c-4.2,5.3-8.3,10.7-16.5,22.1 c-4.3,5.9-9.7,13.4-15.9,22.1c-2.7-2.4-5.8-4.2-9.1-5.5l0,0c-3.4-0.9-7-1.4-10.6-1.4c-21.9-0.3-39.9,17.1-40.3,39s17.1,39.9,39,40.3 c0.4,0,0.8,0,1.3,0c0.9,0,1.8,0,2.7-0.1c7.3,20.6,30,31.4,50.6,24.1c15.9-5.6,26.4-20.6,26.4-37.5c-0.1-3.8-0.6-7.5-1.6-11.1 c-1.8-5.8-5.1-11.1-9.4-15.4c6-8.3,10.6-15.1,13.8-20c4.9-7.4,7.8-12.4,15.2-23.4l6.9-10.3c1.8,1.6,3.9,2.9,6.1,3.8 c21,6.3,43.1-5.6,49.4-26.6c6.3-21-5.6-43.1-26.6-49.4C171.5,28.4,167.6,27.8,163.8,27.8z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M94.3,67.2V14.8c-6.5,7.3-10.1,16.7-10.1,26.4c0,3.9,0.6,7.8,1.7,11.6C87.6,58.2,90.5,63.1,94.3,67.2z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#SVGID_2_)",
  d: "M94.3,78.2l-0.5,0.6c-4.2,5.3-8.3,10.7-16.5,22.1c-4.3,5.9-9.7,13.4-15.9,22.1c-2.7-2.4-5.8-4.2-9.1-5.5 c-3.4-0.9-7-1.4-10.6-1.4c-21.9,0.3-39.4,18.4-39,40.3c0.3,21.4,17.6,38.7,39,39c0.9,0,1.8,0,2.7-0.1c7.3,20.3,29.4,31.1,49.9,24.3 V78.2z"
});

var SvgBone40 = function SvgBone40(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204.9 223.1",
    style: {
      enableBackground: "new 0 0 204.9 223.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.8861,
    y1: 173.2196,
    x2: 95.8479,
    y2: 224.0701,
    gradientTransform: "matrix(1 0 0 -1 0 239.1424)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92B7F"
    }
  }), React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#F93377"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#F75753"
    }
  }), React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F58029"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58524"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED693C"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6D3C"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF773D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1893F"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F28F3F"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDC60B"
    }
  })), _ref4, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3481,
    y1: 23.8095,
    x2: 68.3386,
    y2: 165.4921,
    gradientTransform: "matrix(1 0 0 -1 0 239.1424)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F92B7F"
    }
  }), React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#F93377"
    }
  }), React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#F75753"
    }
  }), React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F58029"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F58524"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED693C"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6D3C"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF773D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F1893F"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F28F3F"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDC60B"
    }
  })), _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBone40, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bone-40.3861a3c1.svg";
export { ForwardRef as ReactComponent };